import { composeRenderProps } from "react-aria-components/composeRenderProps";
import type { DialogProps } from "react-aria-components/Dialog";
import {
	Dialog,
	Modal,
	ModalOverlay,
	type ModalOverlayProps,
} from "react-aria-components/Modal";
import { cn } from "tailwind-variants";

export interface SheetProps extends ModalOverlayProps {
	dialogProps?: Omit<DialogProps, "children">;
}

export function Sheet({
	children,
	className,
	dialogProps,
	...props
}: SheetProps) {
	return (
		<ModalOverlay {...props} className="sheet-overlay">
			{composeRenderProps(children, (children) => (
				<Modal
					className={composeRenderProps(
						className,
						(className) => cn("sheet", className) ?? "sheet",
					)}
				>
					<Dialog {...dialogProps}>{children}</Dialog>
				</Modal>
			))}
		</ModalOverlay>
	);
}
